import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

interface TabPanelProps {
  children?: React.ReactNode;
  index: unknown;
  value: unknown;
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: '16px 0',
    maxWidth: '1284px',
    margin: '0 auto',
  },
}));

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      className={classes.content}
    >
      {value === index && (
        <Box p={3} className={classes.content}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
